import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './assets/index.scss';
import { getEnvironment } from './config/gtm';


if (getEnvironment() === 'prod') {
  const noop = () => {};
  const methods = ['log', 'info', 'warn', 'error', 'debug', 'trace'];

  for (let index = 0; index < methods.length; index += 1) {
    const method = methods[index];
    if (typeof console[method] === 'function') {
      console[method] = noop;
    }
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();
